import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';

export const RETRY_DEPOSIT_ACCOUNT_PAYMENT = 'DEPOSIT_ACCOUNT :: RETRY_PAYMENT';

export type TRetryDepositAccountPaymentAction = IReduxAction<typeof RETRY_DEPOSIT_ACCOUNT_PAYMENT>;

export const retryDepositAccountPayment =
  actionGenerator<typeof RETRY_DEPOSIT_ACCOUNT_PAYMENT>(RETRY_DEPOSIT_ACCOUNT_PAYMENT);
